<template>
  <div>
    <header class="messageHeader">
      <!--<a href="index.html" class="backlastpage"></a>-->
      <p class="headerSpan">09:20</p>
      <div class="writerTop">
        <div>
          取消
        </div>
        <div class="writerC">
          <span to="/message">写一写</span>
           <span>Anthony</span>
        </div>
        <div @click="writer()">发送</div>
      </div>

    </header>
    <div class="text">
      <textarea v-model="text" placeholder=想说点什么.....></textarea>
      <p class="" ><van-uploader v-model="fileList" :after-read="onRead" accept="image/*"  multiple /></p>

      <!--<van-uploader  multiple />-->
    </div>
     <div class="writerBottom">
       <p><van-icon name="location" size="30" color="#6e9bcf" />定位</p>
       <p><van-icon name="browsing-history" size="30" color="#6e9bcf" />公开</p>
     </div>

    <footer class="footerlist divflex">
      <a class="footera divflex">
        <img src="../assets/img/footersy.png" alt="">
        <!--<router-link :to="{name:'homePage'}"><span>首页</span></router-link>-->
        <router-link to="/"><span>首页</span></router-link>

      </a>
      <a class="footera divflex">
        <img src="../assets/img/footertj.png" alt="">
        <!--<span>职位</span>-->
        <router-link to="/position"><span>职位</span></router-link>
      </a>
      <a class="footera divflex">
        <img src="../assets/img/footersb.png" alt="">
        <!--<span>消息</span>-->
        <router-link to="/message"><span>消息</span></router-link>
      </a>
      <!--<a href="service.html" class="footera divflex">-->
      <!--<img src="../assets/img/footersb.png" alt="">-->
      <!--<span>公司</span>-->
      <!--</a>-->
      <a class="footera divflex">
        <img src="../assets/img/footerwd.png" alt="">
        <!--<span>我的</span>-->
        <!--<router-link :to="{name:'homePage'}"><span>我的</span></router-link>-->
        <router-link to="/"><span>我的</span></router-link>
      </a>
    </footer>
  </div>
</template>

<script>
  import axios from "axios"
  export default {
    name: 'message',
    data () {
      return {
        mod_pic_one:"",
        mod_pic_two:"",
        mod_ping_img:"",
        postData:[],
        mod_pic_list:[],
        mod_banner_name:"",
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
//        fileList:[],
        fileList:[
//          {url:"http://zpapi.yuexinduo.com/upload/logo/9fbf386a2243fed0b4e12866e2e17e4d.jpg"},
//          {url:"http://zpapi.yuexinduo.com/upload/logo/9fbf386a2243fed0b4e12866e2e17e4d.jpg"},
//          {url:"http://zpapi.yuexinduo.com/upload/logo/9fbf386a2243fed0b4e12866e2e17e4d.jpg"},
        ],
        list:[
//          "http://zpapi.yuexinduo.com/upload/logo/9fbf386a2243fed0b4e12866e2e17e4d.jpg",
//          "http://zpapi.yuexinduo.com/upload/logo/9fbf386a2243fed0b4e12866e2e17e4d.jpg",
//          "http://zpapi.yuexinduo.com/upload/logo/9fbf386a2243fed0b4e12866e2e17e4d.jpg",
        ],
        text:""
      }
    },
    methods:{
      clickIcon(event){
        console.log(event)
        this.bool=!this.bool
        console.log(this.bool)
//        if(bool){
//          this.color="FFFFFF"
//        }
//        this.color="#FFFFFF"
      },
      onRead(file) {
        var formData = new FormData();
        formData.append('image', file.file); //接口需要传的参数
        axios({
            url:"http://zpapi.yuexinduo.com/index/news/upload",
            method: 'post',
            data: formData,
            processData: false,// 告诉axios不要去处理发送的数据(重要参数)
            contentType: false,// 告诉axios不要去设置Content-Type请求头
            msg:1}
        ).then((res)=>{
//          let src={url:res.imgurl}
//          this.fileList.push({url:res.imgurl});//将图片地址存入一个数组中
          this.postData.push(res.data.imgurl);
        })
      },
      writer(){
        this.$api.write({
          "data[userid]":localStorage.getItem("userid"),
          "data[word]":this.text,
          "img":this.postData
        }).then(res=>{
          if(res.status==200){
            this.$router.push("/")
            this.$toast("发表成功")
          }
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  @import '../assets/css/common.css';
  @import '../assets/css/header.css';
  @import '../assets/css/footer.css';
  /*@import '../assets/css/mui.min.css';*/
  /*<link rel="stylesheet" href="css/mui.min.css">*/
  .headerSpan{
    padding-left: 2rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  .messageHeader{
    width: 100%;
    background-color: #6e9bcf;
    position: fixed;
    top:0;
  }
.writerTop{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #FFFFFF;
  padding: 0 2rem;
}
  .writerC{
    /*display: flex;*/
  }
  .writerC span {
    display: block;
  }
.text {
  margin-top: 6rem;
  width: 80%;
  margin: 6rem auto;
}
  .text textarea{
    width: 100%;
    height: 5rem;
    border: none;
  }
  .writerBottom{
    width: 85%;
   display: flex;
   justify-content: space-between;
    position: fixed;
    bottom: 50px;
    left: 0;
    right: 0;
    margin: auto
  }
  .writerBottom p{
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/writer.vue